import { Star, StarHalf } from "lucide-react";
import { cn } from "../../utils/format";

interface StarsProps {
  rating: number;
  className?: string;
}

/** Estrelas de avaliação (0–5, aceita meia estrela). */
export const Stars = ({ rating, className }: StarsProps) => {
  const value = Math.max(0, Math.min(5, rating));
  return (
    <div
      role="img"
      aria-label={`Avaliação ${value.toLocaleString("pt-BR", { maximumFractionDigits: 1 })} de 5`}
      className={cn("flex items-center gap-0.5", className)}
    >
      {Array.from({ length: 5 }, (_, i) => {
        const full = value >= i + 1;
        const half = !full && value >= i + 0.5;
        return (
          <span key={i} className="relative inline-flex size-3.5">
            <Star aria-hidden="true" className={cn("size-3.5", full ? "fill-primary text-primary" : "text-line")} />
            {half && (
              <StarHalf aria-hidden="true" className="absolute inset-0 size-3.5 fill-primary text-primary" />
            )}
          </span>
        );
      })}
    </div>
  );
};
